(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gk-card-coverflow"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-gk-card-coverflow]';
  const configs = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const create = (config) => {
    const maxWidth = Math.max(1, Number.parseInt(config.dataset.maxWidth || '767', 10));
    const fitCardWidth = Math.max(1, Number.parseFloat(config.dataset.fitCardWidth || '198'));
    const fitGap = Math.max(0, Number.parseFloat(config.dataset.fitGap || '18'));
    const compactMedia = window.matchMedia('(max-width: ' + maxWidth + 'px)');
    const coarseMedia = window.matchMedia('(any-pointer: coarse)');
    const activationMode = config.dataset.activationMode || 'compact';
    const legacyShowControls = config.dataset.showControls === 'true';
    const showArrows = config.dataset.showArrows === 'inherit'
      ? legacyShowControls
      : config.dataset.showArrows === 'true';
    const showPagination = config.dataset.showPagination === 'inherit'
      ? legacyShowControls
      : config.dataset.showPagination === 'true';
    const paginationVariant = config.dataset.paginationVariant === 'dark' ? 'dark' : 'light';
    const paginationLimit = Math.max(0, Number.parseInt(config.dataset.paginationLimit || '0', 10));
    const focusMode = config.dataset.focusMode === 'true';
    const layoutMode = config.dataset.layoutMode || 'default';
    let singleMode = layoutMode === 'single';
    let peekMode = layoutMode === 'peek';
    let multiMode = layoutMode === 'multi';
    let loop = (singleMode || peekMode) ? false : config.dataset.loop !== 'false';

    const state = {
      target: null,
      cards: [],
      activeIndex: 0,
      enabled: false,
      stage: null,
      controls: null,
      prev: null,
      next: null,
      dots: [],
      savedStyles: new Map(),
      savedAttributes: new Map(),
      scrollFrame: 0,
      resizeFrame: 0,
      handlers: null,
      resizeObserver: null,
      observedWidth: 0
    };

    const shouldEnable = () => {
      if (activationMode === 'always') return true;
      if (activationMode === 'fit') {
        let target = null;
        let cards = [];
        try {
          target = document.querySelector(config.dataset.targetSelector || '');
          cards = target
            ? Array.from(target.children).filter((card) => card.matches(config.dataset.slideSelector || ''))
            : [];
        } catch (error) {
          return compactMedia.matches;
        }

        if (!target || target.hidden || target.closest('[hidden]') || cards.length < 2) return false;

        const availableWidth = target.getBoundingClientRect().width || target.clientWidth || 0;
        const requiredWidth = (cards.length * fitCardWidth) + (Math.max(0, cards.length - 1) * fitGap);

        if (!availableWidth) return compactMedia.matches;
        return availableWidth + 1 < requiredWidth;
      }

      if (activationMode === 'touch_or_compact') {
        return compactMedia.matches || coarseMedia.matches || Number(navigator.maxTouchPoints || 0) > 0;
      }
      return compactMedia.matches;
    };

    const query = (css) => {
      try {
        return css ? document.querySelector(css) : null;
      } catch (error) {
        return null;
      }
    };

    const getCards = (target) => {
      try {
        return Array.from(target.children).filter((card) => card.matches(config.dataset.slideSelector || ''));
      } catch (error) {
        return [];
      }
    };

    const startIndex = (cards) => {
      const css = config.dataset.featuredSelector || '';
      if (!css) return 0;
      try {
        const index = cards.findIndex((card) => card.matches(css));
        return index < 0 ? 0 : index;
      } catch (error) {
        return 0;
      }
    };

    const setStyle = (element, property, value) => {
      if (element) element.style.setProperty(property, value, 'important');
    };

    const rememberStyles = (element, properties) => {
      if (!element || state.savedStyles.has(element)) return;
      const values = new Map();
      properties.forEach((property) => {
        values.set(property, [
          element.style.getPropertyValue(property),
          element.style.getPropertyPriority(property)
        ]);
      });
      state.savedStyles.set(element, values);
    };

    const rememberAttributes = (element, attributes) => {
      if (!element || state.savedAttributes.has(element)) return;
      const values = new Map();
      attributes.forEach((attribute) => {
        values.set(attribute, element.hasAttribute(attribute) ? element.getAttribute(attribute) : null);
      });
      state.savedAttributes.set(element, values);
    };

    const restore = () => {
      state.savedStyles.forEach((values, element) => {
        values.forEach(([value, priority], property) => {
          if (value) element.style.setProperty(property, value, priority);
          else element.style.removeProperty(property);
        });
      });
      state.savedAttributes.forEach((values, element) => {
        values.forEach((value, attribute) => {
          if (value === null) element.removeAttribute(attribute);
          else element.setAttribute(attribute, value);
        });
      });
      state.target?.classList.remove('gk-native-scroll-carousel');
      state.target?.removeAttribute('data-gk-coverflow-active');
      state.target?.removeAttribute('data-gk-coverflow-version');
      state.cards.forEach((card) => card.classList.remove('is-gk-carousel-active'));
      state.savedStyles.clear();
      state.savedAttributes.clear();
    };

    const targetLeft = (index) => {
      const card = state.cards[index];
      if (!state.target || !card) return 0;
      if (singleMode || multiMode) {
        const maxLeft = Math.max(0, state.target.scrollWidth - state.target.clientWidth);
        return clamp(card.offsetLeft, 0, maxLeft);
      }
      return Math.max(0, card.offsetLeft - ((state.target.clientWidth - card.offsetWidth) / 2));
    };

    const paintControls = () => {
      let visibleStart = 0;
      let visibleEnd = state.dots.length - 1;
      const compactLimit = compactMedia.matches ? paginationLimit : 0;

      if (compactLimit > 0 && state.dots.length > compactLimit) {
        const halfWindow = Math.floor(compactLimit / 2);
        visibleStart = clamp(state.activeIndex - halfWindow, 0, state.dots.length - compactLimit);
        visibleEnd = visibleStart + compactLimit - 1;
      }

      state.dots.forEach((dot, index) => {
        const active = index === state.activeIndex;
        const visible = compactLimit <= 0 || state.dots.length <= compactLimit || (index >= visibleStart && index <= visibleEnd);
        dot.hidden = !visible;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      if (!loop && state.prev && state.next) {
        const responsiveMulti = layoutMode === 'responsive' && multiMode && state.target;
        const atStart = responsiveMulti ? state.target.scrollLeft <= 1 : state.activeIndex <= 0;
        const atEnd = responsiveMulti
          ? state.target.scrollLeft >= Math.max(0, state.target.scrollWidth - state.target.clientWidth) - 1
          : state.activeIndex >= state.cards.length - 1;
        state.prev.disabled = atStart;
        state.next.disabled = atEnd;
        state.prev.classList.toggle('is-disabled', atStart);
        state.next.classList.toggle('is-disabled', atEnd);
        state.prev.setAttribute('aria-hidden', atStart ? 'true' : 'false');
        state.next.setAttribute('aria-hidden', atEnd ? 'true' : 'false');
      }
    };

    const goTo = (index, smooth = true) => {
      if (!state.target || !state.cards.length) return;
      let next = index;
      if (loop) {
        if (next < 0) next = state.cards.length - 1;
        if (next >= state.cards.length) next = 0;
      } else {
        next = clamp(next, 0, state.cards.length - 1);
      }

      state.activeIndex = next;
      state.target.scrollTo({
        left: targetLeft(next),
        behavior: smooth && !reducedMotion.matches ? 'smooth' : 'auto'
      });
      paintControls();
    };

    const render = () => {
      state.scrollFrame = 0;
      if (!state.enabled || !state.target || !state.cards.length) return;

      if (singleMode || peekMode || multiMode) {
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        state.cards.forEach((card, index) => {
          const distance = Math.abs(targetLeft(index) - state.target.scrollLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        state.activeIndex = nearestIndex;
        state.cards.forEach((card, index) => {
          const active = index === state.activeIndex;
          card.classList.toggle('is-gk-carousel-active', active);
          if (active) card.setAttribute('aria-current', 'true');
          else card.removeAttribute('aria-current');
        });
        paintControls();
        return;
      }

      const trackRect = state.target.getBoundingClientRect();
      const viewportCenter = trackRect.left + (state.target.clientWidth / 2);
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      state.cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + (rect.width / 2);
        const pixelDistance = multiMode
          ? Math.abs(rect.left - trackRect.left)
          : Math.abs(cardCenter - viewportCenter);
        const activeDistance = peekMode
          ? Math.abs(targetLeft(index) - state.target.scrollLeft)
          : pixelDistance;
        const distance = clamp(pixelDistance / Math.max(rect.width, 1), 0, 2);

        if (activeDistance < nearestDistance) {
          nearestDistance = activeDistance;
          nearestIndex = index;
        }

        const scale = multiMode
          ? 1
          : (peekMode
            ? 1
            : (focusMode
              ? Math.max(0.88, 1 - distance * 0.09)
              : Math.max(0.92, 1 - distance * 0.055)));
        const opacity = multiMode
          ? 1
          : (focusMode
            ? Math.max(0.16, 1 - distance * 0.78)
            : Math.max(0.62, 1 - distance * 0.34));
        const blur = multiMode ? 0 : (focusMode ? Math.min(3, distance * 2.2) : 0);
        const brightness = multiMode ? 1 : (focusMode ? Math.max(0.55, 1 - distance * 0.38) : 1);

        setStyle(card, 'transform', 'scale(' + scale.toFixed(4) + ')');
        setStyle(card, 'opacity', opacity.toFixed(3));
        setStyle(card, 'filter', focusMode
          ? 'blur(' + blur.toFixed(2) + 'px) brightness(' + brightness.toFixed(3) + ')'
          : 'none');
        setStyle(card, 'z-index', String(100 - Math.round(distance * 10)));
      });

      state.activeIndex = nearestIndex;
      state.cards.forEach((card, index) => {
        const active = index === state.activeIndex;
        card.classList.toggle('is-gk-carousel-active', active);
        if (active) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      });
      paintControls();
    };

    const scheduleRender = () => {
      if (!state.scrollFrame) state.scrollFrame = requestAnimationFrame(render);
    };

    const attach = () => {
      state.handlers = {
        scroll: scheduleRender,
        keydown: (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          goTo(state.activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
      };
      state.target.addEventListener('scroll', state.handlers.scroll, { passive: true });
      state.target.addEventListener('keydown', state.handlers.keydown);
    };

    const detach = () => {
      if (!state.target || !state.handlers) return;
      state.target.removeEventListener('scroll', state.handlers.scroll);
      state.target.removeEventListener('keydown', state.handlers.keydown);
      state.handlers = null;
    };

    const buildControls = () => {
      if ((!showArrows && !showPagination) || !state.target || !state.target.parentNode) return;

      const stage = document.createElement('div');
      stage.className = 'gk-coverflow-stage';
      stage.setAttribute('data-gk-coverflow-stage', '');
      state.target.parentNode.insertBefore(stage, state.target);

      stage.appendChild(state.target);
      state.stage = stage;

      const controls = document.createElement('div');
      controls.className = 'gk-coverflow-controls';
      controls.setAttribute('data-gk-coverflow-controls', '');
      controls.dataset.gkPaginationVariant = paginationVariant;

      const makeArrow = (direction, label) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'gk-coverflow-arrow gk-coverflow-arrow--' + direction;
        button.setAttribute('aria-label', label);
        const path = direction === 'prev' ? 'M15 4 7 12l8 8' : 'M9 4l8 8-8 8';
        button.innerHTML =
          '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + path + '"/></svg>';
        return button;
      };

      let prev = null;
      let next = null;
      let pagination = null;

      if (showArrows) {
        prev = makeArrow('prev', config.dataset.prevLabel || 'Föregående');
        next = makeArrow('next', config.dataset.nextLabel || 'Nästa');
        prev.addEventListener('click', () => {
          if (!prev.disabled) goTo(state.activeIndex - 1);
        });
        next.addEventListener('click', () => {
          if (!next.disabled) goTo(state.activeIndex + 1);
        });
      }

      if (showPagination) {
        pagination = document.createElement('div');
        pagination.className = 'gk-coverflow-pagination';
        pagination.setAttribute('aria-label', 'Pagination');
        state.dots = state.cards.map((card, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'gk-coverflow-dot';
          dot.setAttribute('aria-label', 'Gå till kort ' + (index + 1));
          dot.addEventListener('click', () => goTo(index));
          pagination.appendChild(dot);
          return dot;
        });
      }

      if (prev) controls.appendChild(prev);
      if (pagination) controls.appendChild(pagination);
      if (next) controls.appendChild(next);
      stage.appendChild(controls);
      state.controls = controls;
      state.prev = prev;
      state.next = next;
      paintControls();
    };

    const removeControls = () => {
      state.controls?.remove();
      state.controls = null;
      state.prev = null;
      state.next = null;
      state.dots = [];
      if (state.stage && state.target && state.stage.parentNode) {
        state.stage.parentNode.insertBefore(state.target, state.stage);
        state.stage.remove();
      }
      state.stage = null;
    };

    const deactivate = () => {
      if (!state.enabled) return;
      if (state.scrollFrame) cancelAnimationFrame(state.scrollFrame);
      if (state.resizeFrame) cancelAnimationFrame(state.resizeFrame);
      state.resizeObserver?.disconnect();
      state.resizeObserver = null;
      state.observedWidth = 0;
      detach();
      restore();
      removeControls();
      state.enabled = false;
      state.cards = [];
      state.activeIndex = 0;
    };

    const activate = (preferredCard = null) => {
      if (state.enabled || !shouldEnable()) return;
      singleMode = layoutMode === 'single';
      peekMode = layoutMode === 'peek' || (layoutMode === 'responsive' && compactMedia.matches);
      multiMode = layoutMode === 'multi' || (layoutMode === 'responsive' && !compactMedia.matches);
      loop = (singleMode || peekMode) ? false : config.dataset.loop !== 'false';
      const target = query(config.dataset.targetSelector || '');
      if (!target || target.hidden || target.closest('[hidden]') || target.hasAttribute('data-gk-coverflow-active')) return;

      const cards = getCards(target);
      if (cards.length < 2) return;

      state.target = target;
      state.cards = cards;

      rememberStyles(target, [
        'position', 'display', 'width', 'max-width', 'height', 'min-height',
        'grid-template-columns', 'grid-auto-flow', 'grid-auto-columns', 'gap', 'justify-content', 'flex-wrap',
        'padding-inline', 'padding-block-start', 'padding-block-end', 'box-sizing', 'overflow', 'overflow-x', 'overflow-y',
        'overscroll-behavior-inline', 'scroll-snap-type', 'scroll-padding-inline',
        'scroll-behavior', 'touch-action', '-webkit-overflow-scrolling'
      ]);
      rememberAttributes(target, ['tabindex', 'role', 'aria-roledescription']);

      cards.forEach((card) => {
        rememberStyles(card, [
          'position', 'left', 'top', 'width', 'max-width', 'min-width', 'margin',
          'margin-inline-start', 'margin-inline-end', 'flex',
          'transform', 'transform-origin', 'transition', 'will-change', 'z-index',
          'visibility', 'opacity', 'filter', 'pointer-events',
          'scroll-snap-align', 'scroll-snap-stop'
        ]);
        rememberAttributes(card, ['aria-current']);
      });

      setStyle(target, 'position', 'relative');
      setStyle(target, 'display', (singleMode || peekMode || multiMode) ? 'flex' : 'grid');
      setStyle(target, 'flex-wrap', 'nowrap');
      if (multiMode) setStyle(target, 'justify-content', 'flex-start');
      setStyle(target, 'width', '100%');
      setStyle(target, 'max-width', 'none');
      setStyle(target, 'height', 'auto');
      setStyle(target, 'min-height', '0');
      setStyle(target, 'grid-template-columns', 'none');
      setStyle(target, 'grid-auto-flow', 'column');
      const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
      const trackWidth = Math.max(1, state.target.clientWidth || viewportWidth);
      const peekCardWidth = Math.min(325, Math.max(280, trackWidth - 88));
      const peekSideInset = Math.max(0, (trackWidth - peekCardWidth) / 2);
      const responsiveWidth = layoutMode === 'responsive' ? window.innerWidth : viewportWidth;
      const multiVisibleCount = responsiveWidth >= 1280 ? 4 : (responsiveWidth >= 1024 ? 3 : (responsiveWidth >= 768 ? 2 : 1));
      const multiGap = 14;
      const multiTrackWidth = trackWidth;
      const multiCardWidth = Math.max(220, (multiTrackWidth - (multiGap * (multiVisibleCount - 1))) / multiVisibleCount);
      setStyle(target, 'grid-auto-columns', (singleMode || peekMode || multiMode) ? 'auto' : (focusMode ? 'calc(100% - 20px)' : 'calc(100% - 24px)'));
      setStyle(target, 'gap', singleMode ? '0' : (multiMode ? multiGap + 'px' : (peekMode ? '10px' : (focusMode ? '18px' : '14px'))));
      setStyle(target, 'padding-inline', (singleMode || peekMode || multiMode) ? '0' : (focusMode ? '10px' : '12px'));
      setStyle(target, 'padding-block-start', peekMode ? '12px' : '0');
      setStyle(target, 'padding-block-end', '0');
      setStyle(target, 'box-sizing', 'border-box');
      setStyle(target, 'overflow-x', 'auto');
      setStyle(target, 'overflow-y', 'hidden');
      setStyle(target, 'overscroll-behavior-inline', 'contain');
      setStyle(target, 'scroll-snap-type', 'x mandatory');
      setStyle(target, 'scroll-padding-inline', (singleMode || peekMode || multiMode) ? '0' : (focusMode ? '10px' : '12px'));
      setStyle(target, 'scroll-behavior', 'auto');
      setStyle(target, 'touch-action', 'auto');

      target.classList.add('gk-native-scroll-carousel');
      target.setAttribute('tabindex', '0');
      target.setAttribute('role', 'region');
      target.setAttribute('aria-roledescription', 'carousel');

      cards.forEach((card, index) => {
        setStyle(card, 'position', 'relative');
        setStyle(card, 'left', 'auto');
        setStyle(card, 'top', 'auto');
        const resolvedCardWidth = singleMode ? trackWidth : (peekMode ? peekCardWidth : (multiMode ? multiCardWidth : null));
        setStyle(card, 'width', resolvedCardWidth ? resolvedCardWidth.toFixed(2) + 'px' : '100%');
        setStyle(card, 'max-width', resolvedCardWidth ? resolvedCardWidth.toFixed(2) + 'px' : 'none');
        setStyle(card, 'min-width', resolvedCardWidth ? resolvedCardWidth.toFixed(2) + 'px' : '0');
        setStyle(card, 'margin', '0');
        setStyle(card, 'margin-inline-start', peekMode && index === 0 ? peekSideInset.toFixed(2) + 'px' : '0');
        setStyle(card, 'margin-inline-end', peekMode && index === cards.length - 1 ? peekSideInset.toFixed(2) + 'px' : '0');
        setStyle(card, 'flex', resolvedCardWidth ? '0 0 ' + resolvedCardWidth.toFixed(2) + 'px' : 'initial');
        setStyle(card, 'transform-origin', '50% 50%');
        setStyle(card, 'transition', (singleMode || peekMode || multiMode || reducedMotion.matches)
          ? 'none'
          : 'transform .16s ease, opacity .16s ease, filter .16s ease');
        setStyle(card, 'will-change', (singleMode || peekMode || multiMode) ? 'auto' : 'transform, opacity, filter');
        setStyle(card, 'visibility', 'visible');
        setStyle(card, 'pointer-events', 'auto');
        setStyle(card, 'scroll-snap-align', (singleMode || multiMode) ? 'start' : 'center');
        setStyle(card, 'scroll-snap-stop', 'normal');
      });

      const preferredIndex = preferredCard ? cards.indexOf(preferredCard) : -1;
      state.activeIndex = preferredIndex >= 0 ? preferredIndex : startIndex(cards);
      state.enabled = true;
      target.setAttribute('data-gk-coverflow-active', 'true');
      target.setAttribute('data-gk-coverflow-version', 'native-scroll-v13-single-slide');

      buildControls();
      attach();

      if ('ResizeObserver' in window) {
        state.observedWidth = Math.round(target.getBoundingClientRect().width);
        state.resizeObserver = new ResizeObserver((entries) => {
          const entry = entries[0];
          if (!entry) return;
          const width = Math.round(entry.contentRect.width);
          if (!width || Math.abs(width - state.observedWidth) < 2) return;
          state.observedWidth = width;
          rebuild();
        });
        state.resizeObserver.observe(target);
      }

      requestAnimationFrame(() => {
        goTo(state.activeIndex, false);
        scheduleRender();
      });
    };

    const sync = () => {
      const target = query(config.dataset.targetSelector || '');
      if (!shouldEnable() || !target || target.hidden || target.closest('[hidden]')) {
        deactivate();
        return;
      }
      if (state.enabled && (!state.target || !state.target.isConnected || state.target !== target)) {
        deactivate();
      }
      activate();
    };

    const rebuild = () => {
      if (state.resizeFrame) cancelAnimationFrame(state.resizeFrame);
      state.resizeFrame = requestAnimationFrame(() => {
        state.resizeFrame = 0;
        const active = state.cards.length ? state.cards[state.activeIndex] : null;
        deactivate();
        activate(active);
      });
    };

    compactMedia.addEventListener?.('change', sync);
    coarseMedia.addEventListener?.('change', sync);

    return {
      sync,
      destroy() {
        deactivate();
        compactMedia.removeEventListener?.('change', sync);
        coarseMedia.removeEventListener?.('change', sync);
      }
    };
  };

  const refresh = () => {
    const live = new Set(document.querySelectorAll(selector));
    configs.forEach((instance, config) => {
      if (!live.has(config)) {
        instance.destroy();
        configs.delete(config);
      }
    });
    live.forEach((config) => {
      if (!configs.has(config)) configs.set(config, create(config));
      configs.get(config).sync();
    });
  };

  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
  document.addEventListener('gk:coverflow:refresh', refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    requestAnimationFrame(refresh);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gk-club-hero-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gk-club-hero-gallery')) {
  class GKClubHeroGallery extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.slides = Array.from(this.querySelectorAll('[data-gk-hero-slide]'));
      if (this.slides.length < 2) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.busy = false;
      this.hovered = false;
      this.inView = true;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = this.dataset.autoplay === 'true' && !this.motion.matches;
      this.delay = Math.max(5, Math.min(10, Number(this.dataset.interval) || 5)) * 1000;
      this.toggle = this.querySelector('[data-gk-hero-toggle]');
      this.status = this.querySelector('[data-gk-hero-status]');
      this.dots = Array.from(this.querySelectorAll('[data-gk-hero-dot]'));
      this.slides.forEach((slide, index) => slide.setAttribute('aria-label', this.dataset.statusLabel.replace('__INDEX__', String(index + 1))));
      this.querySelector('[data-gk-hero-controls]').hidden = false;
      this.toggle.addEventListener('pointerdown', () => { this.toggleIntent = !this.playing; }, options);
      this.toggle.addEventListener('click', () => {
        this.playing = this.toggleIntent ?? !this.playing;
        this.toggleIntent = null;
        this.updatePlayback();
      }, options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => {
        if (index !== this.index) this.step(index - this.index, true);
      }, options));
      this.addEventListener('focusin', () => {
        this.playing = false;
        this.updatePlayback();
      }, options);
      this.addEventListener('mouseenter', () => {
        this.hovered = true;
        this.schedule();
      }, options);
      this.addEventListener('mouseleave', () => {
        this.hovered = false;
        this.schedule();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.step(event.key === 'ArrowLeft' ? -1 : 1, true);
      }, options);
      this.addEventListener('pointerdown', event => {
        this.touch = event.pointerType === 'touch' && !event.target.closest('button') ? { x: event.clientX, y: event.clientY } : null;
      }, options);
      this.addEventListener('pointerup', event => {
        if (!this.touch) return;
        const dx = event.clientX - this.touch.x;
        const dy = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) this.step(dx < 0 ? 1 : -1, true);
      }, options);
      this.addEventListener('pointercancel', () => { this.touch = null; }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.playing = false;
        this.updatePlayback();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule();
      });
      this.observer.observe(this);
      this.updatePlayback();
      const first = this.slides[this.index].querySelector('img');
      if (first?.complete) this.loadImage((this.index + 1) % this.slides.length);
      else first?.addEventListener('load', () => this.loadImage((this.index + 1) % this.slides.length), { ...options, once: true });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.events?.abort();
      this.observer?.disconnect();
      this.events = null;
    }
    loadImage(index) {
      const slide = this.slides[index];
      const template = slide.querySelector('template');
      if (template) {
        slide.append(template.content.cloneNode(true));
        template.remove();
      }
      const image = slide.querySelector('img');
      if (image) image.loading = 'eager';
      return image;
    }
    updatePlayback() {
      this.toggle.setAttribute('aria-label', this.playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      this.querySelector('[data-gk-hero-play]').hidden = this.playing;
      this.querySelector('[data-gk-hero-pause]').hidden = !this.playing;
      this.status.setAttribute('aria-live', this.playing ? 'off' : 'polite');
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.events && this.playing && !this.hovered && this.inView && !document.hidden && !this.busy) {
        this.timer = setTimeout(() => this.step(1, false), this.delay);
      }
    }
    async step(direction, manual) {
      if (manual) {
        this.playing = false;
        this.updatePlayback();
      }
      if (this.busy) return;
      this.busy = true;
      clearTimeout(this.timer);
      const next = (this.index + direction + this.slides.length) % this.slides.length;
      const image = this.loadImage(next);
      let timeout;
      try {
        if (image && !image.complete) {
          await Promise.race([image.decode(), new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('image-timeout')), 8000); })]);
        }
        if (!this.events || !image?.naturalWidth) return;
        this.slides[this.index].classList.remove('is-active');
        this.slides[this.index].setAttribute('aria-hidden', 'true');
        this.slides[next].classList.add('is-active');
        this.slides[next].removeAttribute('aria-hidden');
        this.index = next;
        this.dots.forEach((dot, index) => {
          const active = index === next;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-disabled', 'true');
          else dot.removeAttribute('aria-disabled');
        });
        if (manual) this.status.textContent = this.dataset.statusLabel.replace('__INDEX__', String(next + 1));
        this.loadImage((next + direction + this.slides.length) % this.slides.length);
      } catch {
      } finally {
        clearTimeout(timeout);
        this.busy = false;
        this.schedule();
      }
    }
  }
  customElements.define('gk-club-hero-gallery', GKClubHeroGallery);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gk-club-related-fallback"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-gk-club-recommendations]';
  const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

  const parseImageMap = (root) => {
    try {
      return JSON.parse(root.querySelector('[data-gk-club-image-map]')?.textContent || '{}');
    } catch {
      return {};
    }
  };

  const makeRegionUrl = (region) => {
    const url = new URL('/pages/golfbanor', window.location.origin);
    url.searchParams.set('region', region);
    return url.pathname + url.search;
  };

  const updateClubProfile = (root, current) => {
    const profile = root.closest('.gk-club-profile');
    if (!profile) return;

    const region = current.region;
    const regionUrl = makeRegionUrl(region);
    profile.dataset.gkClubRegion = region;

    const location = profile.querySelector('.gk-club-location > span:last-child');
    if (location) {
      location.textContent = [current.city, region].filter(Boolean).join(', ');
    }

    const intro = profile.querySelector('.gk-club-hero__intro');
    if (intro && !intro.querySelector('.gk-club-eyebrow')) {
      const eyebrow = document.createElement('p');
      eyebrow.className = 'gk-club-eyebrow';
      eyebrow.textContent = 'Golfbanor i ' + region;
      intro.insertBefore(eyebrow, intro.firstChild);
    }

    const breadcrumb = profile.querySelector('.gk-club-breadcrumb');
    const currentCrumb = breadcrumb?.querySelector('[aria-current="page"]');
    if (breadcrumb && currentCrumb && breadcrumb.querySelectorAll('a').length < 2) {
      const before = document.createElement('span');
      before.setAttribute('aria-hidden', 'true');
      before.textContent = '›';
      const areaLink = document.createElement('a');
      areaLink.href = regionUrl;
      areaLink.textContent = region;
      const after = document.createElement('span');
      after.setAttribute('aria-hidden', 'true');
      after.textContent = '›';
      breadcrumb.insertBefore(before, currentCrumb);
      breadcrumb.insertBefore(areaLink, currentCrumb);
      breadcrumb.insertBefore(after, currentCrumb);
    }

    const details = profile.querySelector('.gk-club-details');
    if (details && !Array.from(details.querySelectorAll('dt')).some((item) => item.textContent.trim() === 'Område')) {
      const detail = document.createElement('div');
      const label = document.createElement('dt');
      label.textContent = 'Område';
      const value = document.createElement('dd');
      const link = document.createElement('a');
      link.href = regionUrl;
      link.textContent = region;
      value.appendChild(link);
      detail.append(label, value);
      details.insertBefore(detail, details.firstChild);
    }

    const jsonLd = profile.querySelector('script[type="application/ld+json"]');
    if (jsonLd) {
      try {
        const breadcrumbData = JSON.parse(jsonLd.textContent);
        const items = breadcrumbData.itemListElement;
        if (Array.isArray(items) && items.length === 2) {
          const currentItem = items[1];
          breadcrumbData.itemListElement = [
            items[0],
            { '@type': 'ListItem', position: 2, name: region, item: window.location.origin + regionUrl },
            { ...currentItem, position: 3 }
          ];
          jsonLd.textContent = JSON.stringify(breadcrumbData);
        }
      } catch {}
    }
  };

  const makeCard = (club, imageData) => {
    const card = document.createElement('a');
    card.className = 'gk-club-card';
    card.dataset.gkClubSlide = '';
    card.href = '/pages/golfbanor/' + encodeURIComponent(club.slug);

    if (imageData && typeof imageData.src === 'string' && imageData.src) {
      const image = document.createElement('img');
      image.src = imageData.src;
      image.width = Number(imageData.width) || 1600;
      image.height = Number(imageData.height) || 900;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.alt = '';
      card.appendChild(image);
    }

    const content = document.createElement('div');
    content.className = 'gk-club-card__content';
    const title = document.createElement('h3');
    title.className = 'gk-club-card__title';
    title.textContent = club.name || club.slug;
    const location = document.createElement('p');
    location.className = 'gk-club-card__meta';
    location.textContent = club.region || '';
    content.append(title, location);
    card.appendChild(content);
    return card;
  };

  const initialize = async (root) => {
    if (!root || root.dataset.gkClubRecommendationsReady === 'true') return;
    root.dataset.gkClubRecommendationsReady = 'true';

    try {
      const response = await fetch(root.dataset.golfclubJson);
      if (!response.ok) return;
      const clubs = await response.json();
      const imageMap = parseImageMap(root);
      const currentHandle = root.dataset.currentHandle || '';
      const current = Array.isArray(clubs) ? clubs.find((club) => club && club.slug === currentHandle) : null;
      if (!current || !current.region) return;

      const seen = new Set();
      const recommendations = clubs.filter((club) => {
        const slug = club && typeof club.slug === 'string' ? club.slug : '';
        if (!slug || slug === currentHandle || club.active !== true || club.region !== current.region) return false;
        if (!hasOwn(imageMap, slug) || seen.has(slug)) return false;
        seen.add(slug);
        return true;
      }).slice(0, 20);
      if (!recommendations.length || !root.isConnected) return;

      const carousel = root.querySelector('.gk-club-carousel');
      const grid = root.querySelector('[data-gk-club-carousel]');
      if (!carousel || !grid) return;

      grid.querySelector('[data-gk-club-recommendation-placeholder]')?.remove();
      recommendations.forEach((club) => grid.appendChild(makeCard(club, imageMap[club.slug])));

      const heading = carousel.querySelector('h2');
      if (heading) heading.textContent = 'Andra golfbanor i ' + current.region;

      const cta = carousel.querySelector('.gk-centered a');
      if (cta) {
        const label = Array.from(cta.childNodes).find((node) => node.nodeType === 3);
        if (label) label.nodeValue = 'Visa alla golfbanor i ' + current.region + ' ';
        cta.href = makeRegionUrl(current.region);
      }

      updateClubProfile(root, current);
      root.hidden = false;
      document.dispatchEvent(new Event('gk:coverflow:refresh'));
    } catch {}
  };

  const refresh = (scope) => {
    const roots = scope && scope.matches?.(selector)
      ? [scope]
      : Array.from((scope || document).querySelectorAll(selector));
    roots.forEach((root) => initialize(root));
  };

  document.addEventListener('shopify:section:load', (event) => refresh(event.target));
  document.addEventListener('shopify:section:reorder', () => refresh(document));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refresh(document), { once: true });
  } else {
    requestAnimationFrame(() => refresh(document));
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gk-touch-coverflow"] && !Shopify.designMode) return;
  try {
    (() => {
  const KEY = '__gkTouchCoverflow';
  const CONFIG = '[data-gk-coverflow-config]';
  const coarse = window.matchMedia('(pointer: coarse), (any-pointer: coarse)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (window[KEY]) {
    window[KEY].refresh();
    return;
  }

  const instances = new Map();
  const touchCapable = () => coarse.matches || Number(navigator.maxTouchPoints || 0) > 0;
  const mod = (value, divisor) => ((value % divisor) + divisor) % divisor;

  const create = (config) => {
    const state = {
      targetSelector: config.dataset.targetSelector || '',
      slideSelector: config.dataset.slideSelector || '',
      featuredSelector: config.dataset.featuredSelector || '',
      clipSelector: config.dataset.clipSelector || '',
      target: null,
      clip: null,
      cards: [],
      snapshots: new Map(),
      position: 0,
      pointerId: null,
      startX: 0,
      startY: 0,
      startPosition: 0,
      lastPosition: 0,
      lastTime: 0,
      velocity: 0,
      horizontal: false,
      rejected: false,
      dragged: false,
      suppressClick: false,
      suppressTimer: 0,
      animationFrame: 0,
      renderFrame: 0,
      resizeFrame: 0,
      timers: [],
      metrics: null,
      enabled: false,
      handlers: null
    };

    const important = (element, property, value) => {
      if (element) element.style.setProperty(property, value, 'important');
    };

    const capture = (element, properties) => {
      if (!element || state.snapshots.has(element)) return;
      const snapshot = new Map();
      properties.forEach((property) => {
        snapshot.set(property, {
          value: element.style.getPropertyValue(property),
          priority: element.style.getPropertyPriority(property)
        });
      });
      state.snapshots.set(element, snapshot);
    };

    const restore = (element) => {
      const snapshot = element ? state.snapshots.get(element) : null;
      if (!snapshot) return;
      snapshot.forEach((saved, property) => {
        if (saved.value) element.style.setProperty(property, saved.value, saved.priority);
        else element.style.removeProperty(property);
      });
    };

    const queryTarget = () => {
      try {
        return document.querySelector(state.targetSelector);
      } catch (error) {
        return null;
      }
    };

    const queryClip = () => {
      try {
        return state.clipSelector ? state.target.closest(state.clipSelector) : state.target.parentElement;
      } catch (error) {
        return state.target.parentElement;
      }
    };

    const getCards = () => {
      if (!state.target) return [];
      try {
        return Array.from(state.target.children)
          .filter((child) => child.matches(state.slideSelector))
          .map((card, index) => {
            const order = Number.parseInt(getComputedStyle(card).order, 10);
            return { card, index, order: Number.isFinite(order) ? order : 0 };
          })
          .sort((a, b) => a.order - b.order || a.index - b.index)
          .map((entry) => entry.card);
      } catch (error) {
        return [];
      }
    };

    const relativePosition = (index) => {
      const raw = index - state.position;
      return mod(raw + state.cards.length / 2, state.cards.length) - state.cards.length / 2;
    };

    const cancelAnimation = () => {
      if (!state.animationFrame) return;
      cancelAnimationFrame(state.animationFrame);
      state.animationFrame = 0;
    };

    const render = () => {
      state.renderFrame = 0;
      if (!state.enabled || !state.metrics || state.cards.length < 2) return;

      state.cards.forEach((card, index) => {
        const relative = relativePosition(index);
        const distance = Math.abs(relative);
        const clamped = Math.min(distance, 2.5);
        const x = relative * state.metrics.sideOffset;
        const z = -clamped * state.metrics.depth;
        const rotateY = Math.max(-68, Math.min(68, relative * state.metrics.angleStep));
        const scale = Math.max(0.72, 1 - clamped * state.metrics.scaleStep);
        const visible = distance <= state.metrics.maxVisibleDistance;

        important(card, 'transform', `translate3d(calc(-50% + ${x.toFixed(2)}px),0,${z.toFixed(2)}px) rotateY(${rotateY.toFixed(2)}deg) scale(${scale.toFixed(4)})`);
        important(card, 'z-index', String(1000 - Math.round(distance * 100)));
        important(card, 'visibility', visible ? 'visible' : 'hidden');
        important(card, 'pointer-events', distance < 0.5 ? 'auto' : 'none');
      });
    };

    const scheduleRender = () => {
      if (!state.renderFrame) state.renderFrame = requestAnimationFrame(render);
    };

    const snapTo = (target) => {
      cancelAnimation();
      const from = state.position;
      const distance = target - from;

      if (reducedMotion.matches) {
        state.position = mod(Math.round(target), state.cards.length);
        render();
        return;
      }

      const duration = Math.min(520, 290 + Math.abs(distance) * 90);
      const startedAt = performance.now();
      const step = (now) => {
        const progress = Math.min(1, (now - startedAt) / duration);
        const eased = 1 - Math.pow(1 - progress, 4);
        state.position = from + distance * eased;
        render();
        if (progress < 1) {
          state.animationFrame = requestAnimationFrame(step);
        } else {
          state.animationFrame = 0;
          state.position = mod(Math.round(target), state.cards.length);
          render();
        }
      };
      state.animationFrame = requestAnimationFrame(step);
    };

    const clearGesture = () => {
      state.pointerId = null;
      state.horizontal = false;
      state.rejected = false;
      state.velocity = 0;
    };

    const onPointerDown = (event) => {
      if (!state.enabled || event.isPrimary === false || state.pointerId !== null || event.pointerType === 'mouse') return;
      cancelAnimation();
      state.pointerId = event.pointerId;
      state.startX = event.clientX;
      state.startY = event.clientY;
      state.startPosition = state.position;
      state.lastPosition = state.position;
      state.lastTime = performance.now();
      state.velocity = 0;
      state.horizontal = false;
      state.rejected = false;
      state.dragged = false;
    };

    const onPointerMove = (event) => {
      if (!state.enabled || event.pointerId !== state.pointerId || state.rejected) return;
      const deltaX = event.clientX - state.startX;
      const deltaY = event.clientY - state.startY;
      const absX = Math.abs(deltaX);
      const absY = Math.abs(deltaY);

      if (!state.horizontal) {
        if (absX < 6 && absY < 6) return;
        if (absY > absX) {
          state.rejected = true;
          return;
        }
        state.horizontal = true;
        state.dragged = true;
        try {
          state.target.setPointerCapture(event.pointerId);
        } catch (error) {
        }
      }

      if (event.cancelable) event.preventDefault();
      const next = state.startPosition - deltaX / state.metrics.dragStride;
      const now = performance.now();
      const elapsed = Math.max(1, now - state.lastTime);
      const instant = (next - state.lastPosition) / elapsed;
      state.velocity = state.velocity * 0.66 + instant * 0.34;
      state.position = next;
      state.lastPosition = next;
      state.lastTime = now;
      scheduleRender();
    };

    const finishPointer = (event, cancelled) => {
      if (event.pointerId !== state.pointerId) return;
      if (state.horizontal && state.dragged) {
        state.suppressClick = true;
        clearTimeout(state.suppressTimer);
        state.suppressTimer = window.setTimeout(() => {
          state.suppressClick = false;
        }, 450);
        const projection = cancelled ? 0 : Math.max(-1.15, Math.min(1.15, state.velocity * 175));
        snapTo(Math.round(state.position + projection));
      }
      if (state.target.hasPointerCapture?.(event.pointerId)) {
        try {
          state.target.releasePointerCapture(event.pointerId);
        } catch (error) {
        }
      }
      clearGesture();
    };

    const onClick = (event) => {
      if (!state.suppressClick) return;
      state.suppressClick = false;
      clearTimeout(state.suppressTimer);
      event.preventDefault();
      event.stopImmediatePropagation();
    };

    const restoreLayout = () => {
      restore(state.target);
      restore(state.clip);
      state.cards.forEach(restore);
      state.target?.removeAttribute('data-gk-coverflow-active');
      state.target?.removeAttribute('data-gk-coverflow-version');
    };

    const applyLayout = (activeCard) => {
      restoreLayout();
      const cards = getCards();
      if (cards.length < 2) return false;

      const rects = cards.map((card) => card.getBoundingClientRect());
      const stageWidth = state.target.getBoundingClientRect().width;
      const activeIndex = activeCard ? cards.indexOf(activeCard) : -1;
      const featuredIndex = state.featuredSelector
        ? cards.findIndex((card) => {
            try {
              return card.matches(state.featuredSelector);
            } catch (error) {
              return false;
            }
          })
        : -1;
      const selectedIndex = activeIndex >= 0 ? activeIndex : featuredIndex >= 0 ? featuredIndex : 0;
      const cardWidth = rects[selectedIndex]?.width || 0;
      const maxHeight = Math.max(...rects.map((rect) => rect.height));
      if (!stageWidth || !cardWidth || !maxHeight) return false;

      state.cards = cards;
      state.position = selectedIndex;
      state.metrics = {
        sideOffset: Math.max(cardWidth * 0.56, Math.min(stageWidth * 0.31, cardWidth * 0.74)),
        depth: Math.max(85, Math.min(210, cardWidth * 0.34)),
        angleStep: 46,
        scaleStep: 0.105,
        dragStride: Math.max(150, Math.min(stageWidth * 0.56, cardWidth * 0.84)),
        maxVisibleDistance: stageWidth < 600 ? 1.25 : 2.25
      };

      important(state.clip, 'overflow-x', 'clip');
      important(state.target, 'position', 'relative');
      important(state.target, 'display', 'block');
      important(state.target, 'height', `${Math.ceil(maxHeight)}px`);
      important(state.target, 'perspective', '1400px');
      important(state.target, 'perspective-origin', '50% 50%');
      important(state.target, 'transform-style', 'preserve-3d');
      important(state.target, 'touch-action', 'pan-y');
      important(state.target, 'user-select', 'none');
      important(state.target, '-webkit-user-select', 'none');
      important(state.target, 'overflow', 'visible');
      state.target.setAttribute('data-gk-coverflow-active', 'true');
      state.target.setAttribute('data-gk-coverflow-version', 'coverflow-v5');

      cards.forEach((card, index) => {
        important(card, 'position', 'absolute');
        important(card, 'left', '50%');
        important(card, 'top', '0');
        important(card, 'width', `${rects[index].width.toFixed(2)}px`);
        important(card, 'max-width', `${rects[index].width.toFixed(2)}px`);
        important(card, 'margin', '0');
        important(card, 'transform-origin', '50% 50%');
        important(card, 'transform-style', 'preserve-3d');
        important(card, 'transition', 'none');
        important(card, 'will-change', 'transform');
        important(card, 'backface-visibility', 'hidden');
        important(card, '-webkit-backface-visibility', 'hidden');
      });
      render();
      return true;
    };

    const detachEvents = () => {
      if (!state.handlers || !state.target) return;
      state.target.removeEventListener('pointerdown', state.handlers.pointerdown);
      state.target.removeEventListener('pointermove', state.handlers.pointermove);
      state.target.removeEventListener('pointerup', state.handlers.pointerup);
      state.target.removeEventListener('pointercancel', state.handlers.pointercancel);
      state.target.removeEventListener('click', state.handlers.click, true);
      window.removeEventListener('resize', state.handlers.resize);
      window.removeEventListener('orientationchange', state.handlers.resize);
      state.handlers = null;
    };

    const disable = () => {
      if (!state.enabled) return;
      cancelAnimation();
      if (state.renderFrame) cancelAnimationFrame(state.renderFrame);
      if (state.resizeFrame) cancelAnimationFrame(state.resizeFrame);
      state.timers.forEach(clearTimeout);
      state.timers = [];
      clearTimeout(state.suppressTimer);
      detachEvents();
      restoreLayout();
      state.enabled = false;
      state.cards = [];
      state.metrics = null;
      state.position = 0;
      state.suppressClick = false;
      clearGesture();
    };

    const scheduleMeasure = () => {
      if (!state.enabled) return;
      if (state.resizeFrame) cancelAnimationFrame(state.resizeFrame);
      state.resizeFrame = requestAnimationFrame(() => {
        state.resizeFrame = 0;
        if (!touchCapable()) {
          disable();
          return;
        }
        const index = state.cards.length ? mod(Math.round(state.position), state.cards.length) : 0;
        applyLayout(state.cards[index] || null);
      });
    };

    const attachEvents = () => {
      state.handlers = {
        pointerdown: onPointerDown,
        pointermove: onPointerMove,
        pointerup: (event) => finishPointer(event, false),
        pointercancel: (event) => finishPointer(event, true),
        click: onClick,
        resize: scheduleMeasure
      };
      state.target.addEventListener('pointerdown', state.handlers.pointerdown, { passive: true });
      state.target.addEventListener('pointermove', state.handlers.pointermove, { passive: false });
      state.target.addEventListener('pointerup', state.handlers.pointerup, { passive: true });
      state.target.addEventListener('pointercancel', state.handlers.pointercancel, { passive: true });
      state.target.addEventListener('click', state.handlers.click, true);
      window.addEventListener('resize', state.handlers.resize, { passive: true });
      window.addEventListener('orientationchange', state.handlers.resize, { passive: true });
    };

    const enable = () => {
      if (state.enabled) return true;
      if (!touchCapable()) return false;
      state.target = queryTarget();
      if (!state.target) return false;
      state.clip = queryClip() || state.target.parentElement;
      const cards = getCards();
      if (cards.length < 2) return false;

      capture(state.target, [
        'position', 'display', 'height', 'perspective', 'perspective-origin', 'transform-style',
        'touch-action', 'user-select', '-webkit-user-select', 'overflow', 'overflow-x', 'overflow-y'
      ]);
      capture(state.clip, ['overflow-x']);
      cards.forEach((card) => capture(card, [
        'position', 'left', 'top', 'width', 'max-width', 'margin', 'transform', 'transform-origin',
        'transform-style', 'transition', 'will-change', 'z-index', 'visibility', 'pointer-events',
        'backface-visibility', '-webkit-backface-visibility'
      ]));

      state.cards = cards;
      state.enabled = true;
      if (!applyLayout(null)) {
        state.enabled = false;
        return false;
      }
      attachEvents();
      state.timers = [120, 420, 900, 1500].map((delay) => window.setTimeout(scheduleMeasure, delay));
      return true;
    };

    const sync = () => {
      if (state.enabled && (!state.target || !state.target.isConnected)) {
        disable();
        state.target = null;
        state.clip = null;
        state.snapshots.clear();
      }
      if (touchCapable()) enable();
      else disable();
    };

    return { sync, destroy: disable };
  };

  const refresh = () => {
    const configs = new Set(document.querySelectorAll(CONFIG));
    Array.from(instances.entries()).forEach(([config, instance]) => {
      if (!configs.has(config)) {
        instance.destroy();
        instances.delete(config);
      }
    });
    configs.forEach((config) => {
      let instance = instances.get(config);
      if (!instance) {
        instance = create(config);
        instances.set(config, instance);
      }
      instance.sync();
    });
  };

  const destroy = () => {
    instances.forEach((instance) => instance.destroy());
    instances.clear();
    coarse.removeEventListener?.('change', refresh);
    coarse.removeListener?.(refresh);
    document.removeEventListener('shopify:section:load', refresh);
    document.removeEventListener('shopify:section:unload', refresh);
    delete window[KEY];
  };

  if (typeof coarse.addEventListener === 'function') coarse.addEventListener('change', refresh);
  else coarse.addListener?.(refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  window[KEY] = { refresh, destroy };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else queueMicrotask(refresh);
})();
  } catch(e) { console.error(e); }
})();

})();
